import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import './style.scss';
import { useEffect, useRef, useState } from 'react';
import ChevronIcon from '../../assets/icons/chevron.svg';
export const AccordionItem = ({ title, content, isOpened, onClick, onKeyDown, }) => {
    const contentRef = useRef(null);
    const [height, setHeight] = useState('0');
    useEffect(() => {
        if (isOpened && contentRef.current) {
            setHeight(`${contentRef.current.scrollHeight}px`);
        }
        else {
            setHeight('0');
        }
    }, [isOpened]);
    return (_jsxs("div", { className: `accordion-item${isOpened ? ' item--opened' : ''}`, children: [_jsxs("div", { className: "accordion-item-header", tabIndex: 0, onClick: onClick, onKeyDown: onKeyDown, children: [_jsx("div", { className: "accordion-item-header-title", children: title }), _jsx("div", { className: "accordion-item-header-icon", children: _jsx(ChevronIcon, {}) })] }), _jsx("div", { className: "accordion-item-content", ref: contentRef, style: { height }, inert: !isOpened || undefined, children: _jsx("div", { className: "accordion-item-content-wrapper", children: content }) })] }));
};
export default AccordionItem;
